import { render, staticRenderFns } from "./PurchaseSuppliesProducts.vue?vue&type=template&id=0233610e&scoped=true&"
import script from "./PurchaseSuppliesProducts.vue?vue&type=script&lang=js&"
export * from "./PurchaseSuppliesProducts.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseSuppliesProducts.vue?vue&type=style&index=0&id=0233610e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0233610e",
  null
  
)

export default component.exports